import { useEffect, useState } from 'react'

interface SimpleNotificationProps {
  title: string
  body: string
  type?: 'info' | 'success' | 'warning' | 'error'
  duration?: number
  onClose?: () => void
}

export function SimpleNotification({
  title,
  body,
  type = 'info',
  duration = 5000,
  onClose
}: SimpleNotificationProps) {
  const [isVisible, setIsVisible] = useState(true)

  useEffect(() => {
    if (duration > 0) {
      const timer = setTimeout(() => {
        setIsVisible(false)
        onClose?.()
      }, duration)
      return () => clearTimeout(timer)
    }
  }, [duration, onClose])

  if (!isVisible) return null

  const getTypeStyles = () => {
    switch (type) {
      case 'success':
        return 'bg-green-500 border-green-600'
      case 'warning':
        return 'bg-yellow-500 border-yellow-600'
      case 'error':
        return 'bg-red-500 border-red-600'
      default:
        return 'bg-blue-500 border-blue-600'
    }
  }

  return (
    <div
      className={`fixed top-4 right-4 z-[9999] max-w-sm rounded-full border-l-4 p-4 text-white shadow-lg ${getTypeStyles()}`}
      style={{
        position: 'fixed',
        top: '1rem',
        right: '1rem',
        zIndex: 9999,
        maxWidth: '300px',
        borderRadius: '0.5rem',
        borderLeftWidth: '4px',
        padding: '1rem',
        color: 'white',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        backgroundColor: type === 'success' ? '#22c55e' : 
                        type === 'warning' ? '#eab308' :
                        type === 'error' ? '#ef4444' : '#3b82f6',
        borderLeftColor: type === 'success' ? '#16a34a' :
                        type === 'warning' ? '#ca8a04' :
                        type === 'error' ? '#dc2626' : '#2563eb'
      }}
    >
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <h4 className="font-semibold" style={{ margin: '0 0 0.5rem 0', fontWeight: '600' }}>
            {title}
          </h4>
          <p className="mt-1 text-sm opacity-90" style={{ margin: '0', opacity: '0.9', fontSize: '0.875rem' }}>
            {body}
          </p>
        </div>
        <button
          onClick={() => {
            setIsVisible(false)
            onClose?.()
          }}
          className="ml-4 text-white hover:text-gray-200 focus:outline-none"
          style={{
            marginLeft: '1rem',
            background: 'none',
            border: 'none',
            color: 'white',
            cursor: 'pointer',
            fontSize: '1.125rem',
            padding: '0',
            width: '20px',
            height: '20px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          ×
        </button>
      </div>
    </div>
  )
} 